// Shared with the backend's app/modules/rewards/service.py::calculate_estimated_reward
// normal-customer branch (invoice_amount * 0.05 - 10 * items_count). Both
// QuickQuote.tsx (/quote) and OrderPortal.tsx (/order) show this as a preview
// estimate before the backend computes the real reward at credit time.
export function calculateEstimatedReward(rawItemTotal: number, itemCount: number = 1): number {
  return Math.max(0, rawItemTotal * 0.05 - 10 * itemCount);
}
